    <!-- Header  Section -->
    <header class="hero">

        <!-- Navigation Bar -->
        <nav class="navbar navbar-expand-lg navbar-dark bg-secondary">
            <div class="container-fluid">

                <a class="navbar-brand flex-grow-1" href="/">
                    <img src="./../../../../assets/img/afg-comply365-white.svg" alt="Comply365" height="40" class="d-inline-block align-text-top opacity-50">
                </a>

                <div class="d-flex justify-content-end align-items-center order-lg-3 me-3">
                    <ul class="navbar-nav me-auto">
                        <li class="nav-item dropdown" *ngIf="user && user.firstName!=null">
                            <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="fa fa-fw fa-user me-1"></i>
                                {{user.firstName + ' ' + user.lastName}} | <span *ngIf="!isLender">{{displayedCompany}}</span><span *ngIf="isLender">{{lender?.name}}</span>
                            </a>
                            <ul class="dropdown-menu">
                                <li *ngFor="let c of managerCompanyUserList">
                                    <a href="/company/{{c.companyId}}" class="dropdown-item"><i class="fas fa-cog"></i> {{c.tradingName}}</a>
                                </li>
                                <li>
                                    <a role="menuitem" tabindex="-1" class="dropdown-item" (click)="logOut()"><i class="fas fa-power-off"></i> Logout</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>


                <div class="collapse navbar-collapse order-lg-1" id="navbarNav" *ngIf="!isLender">
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item">
                            <a class="nav-link" [routerLink]="['/dashboard']" [routerLinkActive]="['active']">Dashboard</a>
                        </li>
                        <li class="nav-item" *ngIf="isAdmin">
                            <a class="nav-link" [routerLink]="['/admin']" [routerLinkActive]="['active']">Administrator</a>
                        </li>
                        <!-- DO WE HAVE A SEARCH? -->
                        <!-- <li class="nav-item">
                            <form role="search">
                                <input class="form-control my-2 my-lg-0 ms-lg-2" type="search" placeholder="Search" aria-label="Search">
                            </form>
                        </li> -->
                    </ul>
                </div>

            </div>
        </nav>
    </header>

    <div class="content-wrapper">
        <div class="container-fluid p-4">
             <!-- start: page -->
             <router-outlet></router-outlet>
             <!-- end: page -->

        </div>
    </div>
